import businessIcon from '../../assets/icons/navbar/business-svgrepo-com.svg';
import ic_analytics1 from '../../assets/icons/navbar/ic_analytics1.svg';
import settingsIcon from '../../assets/icons/navbar/settings.svg';
import SvgColor from '../../components/svg-color';
import calendar from '../../assets/icons/navbar/calendar.svg';

// ----------------------------------------------------------------------

const icon = (name) => {
  const iconMap = {
    'tablo': ic_analytics1,
    'business-svgrepo-com': businessIcon,
    'settings': settingsIcon,
    'calendar': calendar,
  };
  
  return (
    <SvgColor src={iconMap[name]} sx={{ width: 1, height: 1 }} />
  );
};

const navConfig = [
  {
    title: 'Табло',
    path: '/admin',
    icon: icon('tablo'),
  },
  {
    title: 'Фирми',
    path: '/admin/companies',
    icon: icon('business-svgrepo-com'),
  },
  {
    title: 'Настройки',
    path: '/admin/settings',
    icon: icon('settings')
  },
  {
    title: 'Работни дни',
    path: '/admin/work-days',
    icon: icon('calendar')
  }
];

export default navConfig;
